import { t } from "i18next";
import { z } from "zod";

export type OptionType = {
  label: string;
  value: string;
  isDisabled?: boolean;
};

export type NumberOptionType = {
  label: string;
  value: number;
  isDisabled?: boolean;
};

export const nonNegativeNumberOrNullInputSchema = z
  .union([z.string(), z.number()])
  .transform(value => (value.toString().trim() === "" ? null : value))
  .nullable()
  .refine(value => value === null || !isNaN(Number(value)), {
    message: t("common:validation.invalidNumber"),
  })
  .transform(value => (value === null ? null : Number(value)))
  .refine(value => value === null || value >= 0, {
    message: t("common:validation.numberMustBeNonNegative"),
  });
export const requiredStringSchema = z
  .string(t("common:validation.requiredField"))
  .trim()
  .min(1, t("common:validation.requiredField"));

export const nonNegativeRequiredNumberSchema = z
  .union([
    z.string(t("common:validation.requiredField")),
    z.number(t("common:validation.requiredField")),
  ]) // Adding a required error here does nothing.
  .transform(value => (value ?? "").toString().trim())
  .refine(value => value !== "", {
    message: t("common:validation.requiredNonNegative"),
  })
  .transform(value => Number(value))
  .refine(value => !isNaN(value) && value >= 0, {
    message: t("common:validation.requiredNonNegative"),
  });

export const positiveRequiredNumberSchema = z
  .union([
    z.string(t("common:validation.requiredField")),
    z.number(t("common:validation.requiredField")),
  ]) // Adding a required error here does nothing.
  .transform(value => (value ?? "").toString().trim())
  .refine(value => value !== "", {
    message: t("common:validation.requiredNonNegative"),
  })
  .transform(value => Number(value))
  .refine(value => !isNaN(value) && value > 0, {
    message: t("common:validation.requiredNonNegative"),
  });
